'use client';

import useSWR from 'swr';

import type { KeywordSearchResponse, KeywordSearchResponseSection, KeywordSearchVariant } from './KeywordSearch.types';

type KeywordSearchSections = {
  /** `undefined` until the first response for this term lands. */
  sections?: KeywordSearchResponseSection[];
  isLoading: boolean;
};

const fetcher = (url: string): Promise<KeywordSearchResponse> => fetch(url).then((res) => res.json());

/**
 * The suggestions behind a search panel. Shared, so the PLP bar can ask whether it has anything to
 * show before opening one: SWR keys on the URL, so the bar and the panel ride the same request.
 */
export const useKeywordSearchSections = (
  searchTerm: string,
  variant: KeywordSearchVariant,
  enabled = true,
): KeywordSearchSections => {
  const { data, isLoading } = useSWR<KeywordSearchResponse>(
    enabled ? `/api/search?q=${encodeURIComponent(searchTerm)}` : null,
    fetcher,
    { refreshInterval: 60000, revalidateOnFocus: false, revalidateOnReconnect: false, keepPreviousData: true },
  );

  // Car suggestions belong to the general open search only; the PLP bar routes to filters or LLM search.
  const sections = variant === 'inline' ? data?.sections?.filter((section) => section.type !== 'cars') : data?.sections;

  return { sections, isLoading };
};
